<template>
  <div class="options">
    <div v-for="option in options" :key="option.name">
      <div class="option inline" v-if="option.show" :key="option.name + option.show">
        <SvgIcon :icon="`description-${option.name}`" class="icon"></SvgIcon>
        <div
          class="grow text"
        >{{ $t(`simulation.product.option.${option.text}`, {price: option.price}) }}</div>
        <button @click="addOption(option.name)">{{ $t('simulation.product.option.add') }}</button>
      </div>
    </div>

    <div class="inline" v-if="hasOptions">
      <button class="stroke" @click="resetRange()">{{ $t('simulation.product.option.remove') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      update: 0,
      products: []
    };
  },
  props: {
    range: null
  },
  computed: {
    options() {
      let options = [];
      let availableOptions = ["fix", "longer", "green"];

      availableOptions.forEach(option => {
        let newRange = this.getNewRange(option);

        options.push({
          name: option,
          show: newRange.options[option].length,
          text: `${option}.${newRange.options[option].join("-")}`,
          price: (
            newRange.amounts.monthlyAmount - this.range.amounts.monthlyAmount
          ).toFixed(2).replace('.', ',')
        });
      });

      return options;
    },
    hasOptions() {
      let hasOptions = Object.keys(this.range.options)
        .map(key => this.range.options[key].length)
        .reduce((accumulator, i) => {
          return (accumulator += i);
        });

      return hasOptions;
    },
    hasElec() {
      return this.range.electricity !== undefined;
    },
    hasGas() {
      return this.range.gas !== undefined;
    }
  },
  methods: {
    getNewRange(option) {
      return this.$store.getters["simulation/rangeByOption"](
        this.range,
        option
      );
    },
    resetRange() {
      let newRange = this.$store.getters["simulation/defaultRange"](this.range);
      this.$emit("newRange", newRange);
    },
    addOption(option) {
      let newRange = this.getNewRange(option);
      this.$emit("newRange", newRange);
    }
  },
  filters: {
    toCurrency: function(value) {
      return value.toFixed(2).replace('.', ',');
    }
  }
};
</script>

<style lang="scss" scoped>
.options {
  margin: 10px 0;
  font-size: 0.9rem;

  .option {
    text-align: left;
    margin-bottom: 20px;
    background: #eee;
    padding: 30px 20px;

    .icon {
      font-size: 1.6rem;
      margin-right: 10px;
    }

    button {
      margin-left: 10px;
      font-size: 0.8rem;
      border: 0;
      border-radius: 20px;
      padding: 5px 10px;
      text-decoration: none;
      background: black;
      color: #fdcb47;
    }
  }

  button.stroke {
    margin-left: 10px;
    font-size: 0.8rem;
    border: 0;
    border-radius: 20px;
    padding: 5px 10px;
    text-decoration: none;
    border: 1px solid #fdcb47;
    background: none;
    color: black;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/simulation/Options.vue